export const blogPosts = [
  {
    id: '1',
    title: 'Güneş Enerjisi Sistemlerinde Verimlilik',
    content: 'Güneş enerjisi sistemlerinde verimliliği artırmak için dikkat edilmesi gereken en önemli faktörler panel açısı, düzenli bakım ve doğru inverter seçimidir. Panellerin güneş ışınlarını optimum açıda alması için coğrafi konuma göre hesaplama yapılmalıdır...',
    excerpt: 'Güneş enerjisi sistemlerinizden maksimum verim almak için önemli ipuçları',
    author: 'Ahmet Yılmaz',
    date: '2024-03-08',
    slug: 'gunes-enerjisi-sistemlerinde-verimlilik',
    imageUrl: 'https://picsum.photos/800/400',
    tags: ['Güneş Enerjisi', 'Verimlilik', 'Teknoloji']
  },
  {
    id: '2',
    title: 'Enerji İzleme Sistemlerinin Avantajları',
    content: 'Modern enerji izleme sistemleri, işletmelerin enerji tüketimini gerçek zamanlı olarak takip etmelerini sağlar. Bu sistemler sayesinde enerji kayıpları tespit edilebilir, tüketim optimize edilebilir ve maliyetler düşürülebilir...',
    excerpt: 'Enerji izleme sistemleri ile işletmenizin verimliliğini artırın',
    author: 'Zeynep Kaya',
    date: '2024-03-09',
    slug: 'enerji-izleme-sistemlerinin-avantajlari',
    imageUrl: 'https://picsum.photos/800/400',
    tags: ['Enerji İzleme', 'Verimlilik', 'Endüstri']
  },
  {
    id: '3',
    title: 'Akıllı Şebekelerin Geleceği',
    content: 'Akıllı şebekeler, elektrik dağıtım sistemlerinin geleceğini şekillendiriyor. IoT teknolojileri ve yapay zeka ile desteklenen bu sistemler, enerji dağıtımını daha verimli ve sürdürülebilir hale getiriyor...',
    excerpt: 'Elektrik dağıtım sistemlerinde yeni dönem: Akıllı Şebekeler',
    author: 'Mehmet Demir',
    date: '2024-03-10',
    slug: 'akilli-sebekelerin-gelecegi',
    imageUrl: 'https://picsum.photos/800/400',
    tags: ['Akıllı Şebeke', 'IoT', 'Teknoloji', 'İnovasyon']
  }
]; 